"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlPendingPreauthsValidation = void 0;
const PaymentTerminalControlPaymentWithPayloadValidation_1 = require("./PaymentTerminalControlPaymentWithPayloadValidation");
const PaymentTransactionValidation_1 = require("./PaymentTransactionValidation");
class PaymentTerminalControlPendingPreauthsValidation {
    static isValid(entity) {
        // Validate entity.pending_preauths for existence and correct type.
        if (entity.pending_preauths == undefined)
            return false;
        if (!Array.isArray(entity.pending_preauths))
            return false;
        if (!entity.pending_preauths.every((elem) => {
            if (!PaymentTerminalControlPaymentWithPayloadValidation_1.PaymentTerminalControlPaymentWithPayloadValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        // If entity.failed_session_persisted_preauths exists, validate that it has the correct type.
        if (entity.failed_session_persisted_preauths != undefined) {
            if (!Array.isArray(entity.failed_session_persisted_preauths))
                return false;
            if (!entity.failed_session_persisted_preauths.every((elem) => {
                if (!PaymentTransactionValidation_1.PaymentTransactionValidation.isValid(elem))
                    return false;
                return true;
            }))
                return false;
        }
        return true;
    }
}
exports.PaymentTerminalControlPendingPreauthsValidation = PaymentTerminalControlPendingPreauthsValidation;
